import _JSXStyle from "styled-jsx/style";
import { colors, spacers } from '@dhis2/ui-constants';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const SingleSelectOption = _ref => {
  let {
    label,
    active,
    disabled,
    onClick,
    className,
    dataTest,
    value
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    onClick: e => onClick({}, e),
    "data-test": dataTest,
    "data-value": value,
    "data-label": label,
    className: _JSXStyle.dynamic([["3808134379", [colors.grey900, spacers.dp8, spacers.dp12, colors.grey200, colors.teal700, colors.white, colors.grey500]]]) + " " + (cx(className, {
      disabled,
      active
    }) || "")
  }, label, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3808134379",
    dynamic: [colors.grey900, spacers.dp8, spacers.dp12, colors.grey200, colors.teal700, colors.white, colors.grey500]
  }, ["div.__jsx-style-dynamic-selector{cursor:pointer;font-size:14px;-webkit-text-decoration:none;text-decoration:none;color:".concat(colors.grey900, ";padding-block:").concat(spacers.dp8, ";padding-inline:").concat(spacers.dp12, ";}"), "div.__jsx-style-dynamic-selector:hover{background-color:".concat(colors.grey200, ";}"), "div.__jsx-style-dynamic-selector:active,div.active.__jsx-style-dynamic-selector{background-color:".concat(colors.teal700, ";color:").concat(colors.white, ";cursor:auto;}"), "div.disabled.__jsx-style-dynamic-selector{color:".concat(colors.grey500, ";cursor:not-allowed;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}"), "div.disabled.__jsx-style-dynamic-selector:hover{background-color:initial;}"]));
};

SingleSelectOption.defaultProps = {
  dataTest: 'dhis2-uicore-singleselectoption'
};
SingleSelectOption.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  active: PropTypes.bool,
  className: PropTypes.string,
  dataTest: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};
export { SingleSelectOption };